import React from "react";
import { ArrowRight, BookOpen, Hand, GraduationCap, Users, Building2 } from "lucide-react";

/* Replaces four legacy on-home sections (WhatIsBSL, Fingerspelling,
   FingerspellShowcase, UseCases) with a single tight linking strip.
   Each card points to the dedicated page that already exists for
   that topic - this avoids duplicated content competing in search
   results and keeps the homepage tightly funnelled towards the
   course-conversion sections below. */
const CARDS = [
  {
    icon: BookOpen,
    eyebrow: "Background",
    title: "What is British Sign Language?",
    blurb:
      "Learn what British Sign Language is, where it came from and how it’s used today.",
    href: "/what-is-bsl",
    cta: "Read the explainer",
  },
  {
    icon: Hand,
    eyebrow: "Free tool",
    title: "Fingerspelling alphabet & player",
    blurb:
      "Watch any word, name or phrase fingerspelled. Free chart, looped player and a print-a-name maker. Use it before, during or after the course.",
    href: "/fingerspell",
    cta: "Try the player",
  },
  {
    icon: GraduationCap,
    eyebrow: "For schools",
    title: "Lesson plans and classroom resources",
    blurb:
      "Two lesson plans for KS2 to KS4 with presentations and printable resources, plus end-of-term fingerspelling games. No previous BSL needed.",
    href: "/for-schools",
    cta: "See schools resources",
  },
  {
    icon: Users,
    eyebrow: "Free resources for groups",
    title: "Lesson plans and printables for tutors, libraries and youth groups",
    blurb:
      "Lesson plans, printable resources and guidance for tutors, libraries, Scouts, Guides and community groups.",
    href: "/lesson-plans",
    cta: "See group resources",
  },
  {
    icon: Building2,
    eyebrow: "BSL course for organisations",
    title: "Enrol your team on the online BSL course",
    blurb:
      "Enrol your staff or learners together, with individual logins, progress tracking, and each learner can earn their own certificate. From £5 per learner.",
    href: "/groups",
    cta: "See team enrolment",
  },
];

const HomeExploreMore = () => {
  return (
    <section className="bs-explore" data-testid="home-explore-more">
      <div className="bs-container">
        <div className="bs-section-head">
          <span className="bs-eyebrow">Learn more</span>
          <h2 className="bs-h2">More ways to learn</h2>
          <p className="bs-section-head__sub">
            Background reading, free tools, and resources for schools and groups.
          </p>
        </div>

        <ul className="bs-explore__grid">
          {CARDS.map((c) => {
            const Icon = c.icon;
            return (
              <li key={c.href} className="bs-explore__card">
                <a
                  href={c.href}
                  className="bs-explore__link"
                  data-testid={`home-explore-link-${c.href.replace(/\//g, "")}`}
                >
                  <span className="bs-explore__icon" aria-hidden="true">
                    <Icon size={20} />
                  </span>
                  <span className="bs-explore__eyebrow">{c.eyebrow}</span>
                  <h3 className="bs-explore__title">{c.title}</h3>
                  <p className="bs-explore__blurb">{c.blurb}</p>
                  <span className="bs-explore__cta">
                    {c.cta}
                    <ArrowRight size={14} />
                  </span>
                </a>
              </li>
            );
          })}
        </ul>
      </div>
    </section>
  );
};

export default HomeExploreMore;
